import Badge from '@cavilha/badge';
import Checkbox from '@cavilha/checkbox';
import Text from '@cavilha/text';
import { css } from '@cavilha/theme';
import { useListFilter } from '@hooks/algolia/useListFilter';
import { useState } from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';

type RefinementListItem = {
  label: string;
  value: string[];
  count: number;
  isRefined: boolean;
};

type RefinementListProps = {
  attribute: string;
  items: RefinementListItem[];
  refine: Function;
  limit?: number;
  showMore?: boolean;
  threesteps?: boolean;
  indexPosition?: number;
};

function RefinementList({
  attribute,
  items,
  refine,
  limit = 10,
  showMore = true,
  threesteps = false,
  indexPosition,
}: RefinementListProps) {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const { trackListFilter } = useListFilter();

  const parseAttributeLabel = (label: string) => {
    if (attribute.endsWith('(kg)')) {
      return `${label} kg`;
    }
    if (label === 'true') {
      return 'Sim';
    }
    if (label === 'false') {
      return 'Não';
    }
    return label;
  };

  return (
    <>
      {items.map(
        ({ label, isRefined, count, value }, i: number) =>
          (i < limit || isExpanded) && (
            <Checkbox
              className={css({
                '& > div': {
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              })}
              key={label}
              onCheckedChange={() => {
                if (!isRefined)
                  trackListFilter({
                    typeName: attribute,
                    elementPosition: i + 1,
                    elementName: label,
                    typeFixedPosition: indexPosition,
                    isThreeSteps: threesteps,
                  });
                refine(value);
              }}
              checked={isRefined}
              defaultChecked={isRefined}
              css={{
                '& i': {
                  display: 'block',
                  lineHeight: '16px',
                },
              }}
              label={
                <>
                  <Text size="bodySmall" css={{ marginRight: '$small1' }}>
                    {parseAttributeLabel(label)}
                  </Text>
                  <Badge css={{ fontSize: '$bodyXSmall' }} count={count} overflowCount={100000} />
                </>
              }
            />
          )
      )}

      {showMore && items.length > limit && (
        <Text
          as="a"
          textStyle="bodySmallSemibold"
          css={{
            cursor: 'pointer',
            color: '$secondary4',
          }}
          onClick={event => {
            event.preventDefault();
            setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? 'Ver menos' : 'Ver mais'}
        </Text>
      )}
    </>
  );
}

export default connectRefinementList(RefinementList);
